<template>
  <div class="row">
    <div class="col-sm-6">
      <transition name="el-fade-in-linear">
        <supplier-data :supplier="supplier" v-if="supplier" />
      </transition>
    </div>
    <div class="col-sm-6">
      <div style="margin-bottom: 1em; gap: 1rem;" class="d-flex">
        <router-link
          :to="`/suppliers/${supplier.id}/products`"
          class="btn btn-warning btn-xs"
          v-if="supplier"
        >
          <i class="fas fa-boxes" aria-hidden="true"></i>
          Produkte anzeigen
        </router-link>
        <router-link
          :to="`/orders/create?supplier=${supplier.id}`"
          class="btn btn-warning btn-xs"
          v-if="supplier"
        >
          <i class="fas fa-shopping-cart" aria-hidden="true"></i>
          Neue Bestellung
        </router-link>
      </div>
      <card>
        <template slot="header">
          <div class="d-flex justify-content-between">
            <h4 class="card-title">Ansprechpartner</h4>
            <button type="submit" class="btn btn-fill btn-primary"
              @click="$router.push(`/suppliers/${supplier.id}/contact_people/create`)"
              v-if="supplier"
            >
              Hinzufügen
            </button>
          </div>
        </template>
        <transition name="el-fade-in-linear">
          <contact-people-table v-if="contactPeople.length"
            :contactPeople="contactPeople"
          />
        </transition>
      </card>
      <card>
        <template slot="header">
          <div class="d-flex justify-content-between">
            <h4 class="card-title">Dateien</h4>
            <button type="submit" class="btn btn-fill btn-primary"
              @click="openFileUploadDialog"
            >
              Hochladen
            </button>
          </div>
        </template>
        <div class="row" v-if="files.length">
          <div class="col-sm-4" v-for="file in files" :key="file.id" style="padding-bottom: 1em;">
            <a :href="`${api}/suppliers/${supplier.id}/files/${file.file.id}`" :class="fileEditMode ? 'custom-link-danger' : 'custom-link'"
              @click="fileClick(file, $event)"
            >
              <div class="text-center">
                <i class="fas" :class="fileEditMode ? 'fa-trash' : 'fa-file'" style="font-size: 1.25em;"></i><br>
                {{ file.date | date }}<br>
                {{ file.file.original_name }}
              </div>
            </a>
          </div>
        </div>
        <p v-else>Keine Dateien vorhanden</p>
        <template slot="footer" v-if="files.length">
          <div class="text-center">
            <a href="#" @click.prevent="fileEditMode = !fileEditMode" class="custom-link">{{ fileEditMode ? 'Löschen beenden' : 'Dateien löschen' }}</a>
          </div>
        </template>
      </card>
      <card>
        <template slot="header">
          <div class="d-flex justify-content-between">
            <h4 class="card-title">Letzten Bestellungen</h4>
            <button type="submit" class="btn btn-fill btn-primary"
              @click="$router.push(`/orders?supplier=${supplier.id}`)"
            >
              Alle anzeigen
            </button>
          </div>
        </template>
        <orders-table v-if="orders.length"
          :orders="orders" :show-supplier="false"
        />
        <p v-else>Keine Bestellungen vorhanden</p>
      </card>
      <!-- <card>
        <template slot="header">
          <div class="d-flex justify-content-between">
            <h4 class="card-title">Produkte</h4>
            <button type="submit" class="btn btn-fill btn-primary"
              @click="openAssignProductDialog"
            >
              Zuweisen
            </button>
          </div>
        </template>
        <table class="table" v-if="supplierProducts.length">
          <thead>
            <tr>
              <th>Produkt</th>
              <th class="text-center">Preis</th>
              <th class="text-center">Datum</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in supplierProducts" :key="product.id">
              <td v-text="product.product.name"></td>
              <td class="text-right">{{ product.price | priceFromCent }}</td>
              <td class="text-right">{{ product.created_at | date }}</td>
              <td class="text-right">
                <div class="td-actions">
                  <a v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-xs"
                    @click="deleteSupplierProduct(product)"
                  >
                    <i class="fa fa-close"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <p v-else>Keine Produkte zugewiesen</p>
      </card> -->
    </div>
    <file-upload-dialog
      :show="showFileUploadDialog"
      @submit="uploadFile"
      @close="closeFileUploadDialog"
      :val-errors="uploadErrors"
    />
    <assign-product-dialog
      :show="showAssignProductDialog"
      :products="products"
      @assignProduct="assignProduct"
      @close="showAssignProductDialog = false"
      :val-errors="assignErrors"
    />
  </div>
</template>

<script>
import FileUploadDialog from './file-upload-dialog'
import AssignProductDialog from './assign-product-dialog'
import ContactPeopleTable from './contact-people-table'
import SupplierData from './supplier-data'
import OrdersTable from './../Orders/orders-table'
import api from 'src/api'

export default {
  components: { FileUploadDialog, AssignProductDialog, SupplierData, ContactPeopleTable, OrdersTable },
  data () {
    return {
      supplier: null,
      files: [],
      uploadErrors: [],
      showFileUploadDialog: false,
      api,
      fileEditMode: false,
      supplierProducts: [],
      products: [],
      showAssignProductDialog: false,
      assignErrors: [],
      contactPeople: [],
      orders: []
    }
  },
  methods: {
    openFileUploadDialog () {
      this.showFileUploadDialog = true
    },
    closeFileUploadDialog () {
      this.showFileUploadDialog = false
    },
    async uploadFile (payload) {
      await this.initCsrf()

      this.$http.post(`/suppliers/${this.supplier.id}/files`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(({ data }) => {
        this.files.unshift(data)
        this.fileEditMode = false
        this.closeFileUploadDialog()
      }).catch(({ response }) => { this.uploadErrors = response.data.errors })
    },
    async fileClick (file, event) {
      if (this.fileEditMode) {
        event.preventDefault()
        if (confirm(`Datei ${file.file.original_name} wirklich löschen?`)) {
          await this.initCsrf()

          this.$http.delete(`/suppliers/${this.supplier.id}/files/${file.id}`).then(({ data }) => {
            this.$notify({
              message: `Datei ${data.file.original_name} erfolgreich gelöscht.`,
              type: 'success'
            })
            const index = this.files.findIndex(({ id }) => data.id === id)
            this.files.splice(index, 1)
          })
        }
      }
    },
    openAssignProductDialog () {
      let loadProducts = Promise.resolve()
      if (!this.products.length) {
        loadProducts = this.$http.get(`/products?not_supplier=${this.supplier.id}`).then(({ data }) => {
          this.products = data
        })
      }
      loadProducts.then(() => { this.showAssignProductDialog = true })
    },
    async assignProduct (payload) {
      await this.initCsrf()

      const url = `/suppliers/${this.supplier.id}/products/${payload.product_id}`
      this.$http.post(url, { price: payload.price }).then(({ data }) => {
        this.$notify({
          message: 'Lieferant erfolgreich dem Produkt zugewiesen.',
          type: 'success'
        })
        this.showAssignProductDialog = false
        this.supplierProducts.push(data)
      }).catch(({ response }) => { this.assignErrors = response.data.errors })
    },
    async deleteSupplierProduct (product) {
      if (confirm('Zuweisung des Produkts wirklich löschen?')) {
        await this.initCsrf()

        this.$http.delete(`/product_supplier/${product.id}`).then(({ data }) => {
          const index = this.supplierProducts.findIndex(({ id }) => id === data.id)
          this.supplierProducts.splice(index, 1)
        })
      }
    }
  },
  created () {
    this.$http.get(`/suppliers/${this.$route.params.id}`).then(({ data }) => {
      this.supplier = data
    })
    this.$http.get(`/suppliers/${this.$route.params.id}/files`).then(({ data }) => {
      this.files = data
    })
    this.$http.get(`/suppliers/${this.$route.params.id}/products`).then(({ data }) => {
      this.supplierProducts = data
    })
    this.$http.get(`/suppliers/${this.$route.params.id}/contact_people`).then(({ data }) => {
      this.contactPeople = data
    })
    this.$http.get(`/orders?supplier=${this.$route.params.id}&limit=5`).then(({ data }) => {
      this.orders = data
    })
  }
}
</script>

<style>
</style>
